import type { MissionOutcome, MissionStage } from '@frontier/content/contracts';

export const stageLabels: Record<MissionStage, string> = {
  outbound: 'ПЕРЕХОД', engage: 'БОЙ', collect: 'ПОИСК', return: 'ВОЗВРАЩЕНИЕ', settled: 'ЗАВЕРШЕНО',
};
export const outcomeLabels: Record<MissionOutcome, string> = {
  active: 'Вылет продолжается', success: 'Контракт выполнен', partial: 'Частичная сдача',
  diverted: 'Маршрут изменён', failed: 'Контракт не выполнен',
};
export function passiveInfo(id: string): { name: string; description: string; symbol: string } {
  if (id === 'targeting') return { name: 'Дальномер', description: '+15% к дальности оружия.', symbol: '⌖' };
  if (id === 'capacitor') return { name: 'Конденсатор', description: 'Увеличенный запас энергии для форсажа и активных модулей.', symbol: 'ϟ' };
  if (id === 'repair-drone') return { name: 'Ремонтный дрон', description: 'Медленно восстанавливает корпус, когда корабль вышел из боя.', symbol: '+' };
  if (id === 'thrusters') return { name: 'Усиленные двигатели', description: '+15% к скорости только во время форсажа. Расход энергии прежний.', symbol: '»' };
  return { name: 'Без усилителя', description: '', symbol: '—' };
}
